import * as actions from './campaign/actions'
import * as mutations from './campaign/mutations'
import * as getters from './campaign/getters'

import { dataProps } from './campaign/properties'

const state = {
    list: [],
    nav: {
        page_number: 1, 
        had_results: false,
        limit: 10,
        total: 0,
        sort_column_name: 't1.id',
        sort_direction: 1, 
        search: ''
    },
    props: JSON.parse(JSON.stringify(dataProps))
}

export default {
    state,
    getters,
    mutations,
    actions
}


// WEBPACK FOOTER //
// ./src/store/modules/campaign.js